import { render, staticRenderFns } from "./TransferDocument.vue?vue&type=template&id=9dc53d40&"
import script from "./TransferDocument.vue?vue&type=script&lang=js&"
export * from "./TransferDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports